// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 513 ? "photo-editor" : chunkId) + "." + {"276":"cf6d6692","426":"aac54615","513":"b3f71d38","595":"cb8a375b","786":"64503547","860":"d16c7085"}[chunkId] + ".chunk.js";
};